import { StudyInfoV1 } from '@csp/dmdp-api-study-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { StudyStatus } from '@csp/csp-common-model';

export const studyInfoV1Mock: StudyInfoV1 = {
  dcode: 'dcode',
  name: 'externalId',
  status: StudyStatus.ACTREC,
};

export const createStudyInfoV1Mock = createMockCreator(studyInfoV1Mock);
